import React, { useRef, useState } from "react";
import "./Sport_programs.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import Sport_card from "../../common-components/common-cards/sport-card/Sport_card";

const Sport_programs = () => {
  const sportsData = [
    {
      id: 1,
      sportIcon: "/assets/images/home/our-sports/group-fitness.png",
      name: "Group fitness for Adults",
      discription:
        "Engaging group fitness sessions designed for adults of all levels.",
    },
    {
      id: 2,
      sportIcon: "/assets/images/home/our-sports/personal-training.png",
      name: "Personal Training",
      discription:
        "One-on-one training sessions tailored to individual fitness goals.",
    },
    {
      id: 3,
      sportIcon: "/assets/images/home/our-sports/marathon.png",
      name: "Marathon Training",
      discription: "Comprehensive training programs for marathon enthusiasts.",
    },
    {
      id: 4,
      sportIcon: "/assets/images/home/our-sports/kids-fitness.png",
      name: "Kids Fitness",
      discription: "Fun and engaging fitness programs for children.",
    },
    {
      id: 5,
      sportIcon: "/assets/images/home/our-sports/Kids-athletics.png",
      name: "Kids Athletics",
      discription: "Athletic training programs designed specifically for kids.",
    },
    {
      id: 6,
      sportIcon: "/assets/images/home/our-sports/marathon.png",
      name: "Marathon Training",
      discription: "Comprehensive training programs for marathon enthusiasts.",
    },
    {
      id: 7,
      sportIcon: "/assets/images/home/our-sports/Kids-athletics.png",
      name: "Kids Athletics",
      discription: "Athletic training programs designed specifically for kids.",
    },
    {
      id: 8,
      sportIcon: "/assets/images/home/our-sports/personal-training.png",
      name: "Personal Training",
      discription:
        "One-on-one training sessions tailored to individual fitness goals.",
    },
  ];

  return (
    <>
      <section className="homesportprog_sec">
        <div className="container">
          <Heading_title
            title={"Our Activities"}
            subtitle={
              "Explore a wide range of sports programs designed for all skill levels"
            }
          />

          <div className="slidersec">
            <Swiper
              slidesPerView={1}
              spaceBetween={10}
              navigation={true}
              modules={[Navigation]}
              breakpoints={{
                "0": {
                  slidesPerView: 1.5,
                  spaceBetween: 8,
                },
                "350": {
                  slidesPerView: 2,
                  spaceBetween: 8,
                },
                "480": {
                  slidesPerView: 2.5,
                  spaceBetween: 8,
                },
                "575": {
                  slidesPerView: 2.5,
                  spaceBetween: 10,
                },
                "768": {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                "992": {
                  slidesPerView: 4.5,
                  spaceBetween: 20,
                },
                "1200": {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
                "1400": {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
              }}
              className="mySwiper"
            >
              {sportsData.map((data, index) => (
                <SwiperSlide>
                  <Sport_card
                    sportIcon={data.sportIcon}
                    name={data.name}
                    discription={data.discription}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sport_programs;
